import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow-y: scroll;
  max-height: 348px;
  background: #f4f7fe;
  border-radius: 3px;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #d1e1fc;
  padding-top: 20px;
`;

export const DrugDosage = styled.div`
  padding-left: 5px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
  flex-direction: column;
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    color: #1c1413;
  }
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    color: #7a7a7a;
  }
`;

export const DosageAndButton = styled.div`
  padding-right: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 100%;

    color: #1756e8;
  }
`;

export const Information = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
`;

export const Word = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 50%;
  color: #7a7a7a;
`;

export const Result = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 9px;
  line-height: 50%;
  color: #7a7a7a;
`;
